export enum I18nSetNamespace {
    String = "string"
}